module.exports = ".menu-item.logout {\n    cursor: pointer;\n}\nnac-alert-center {\n    position: fixed;\n    z-index: 1000;\n    width: 100%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/navbar/navbar.component.css
// module id = ./src/app/theme/navbar/navbar.component.css
// module chunks = main